import { render, staticRenderFns } from "./TheHeaderBar.vue?vue&type=template&id=06e3a192&"
import script from "./TheHeaderBar.vue?vue&type=script&lang=ts&"
export * from "./TheHeaderBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports